<MapOverlay class="MyLocationTool" :position="coords" :map="map">
    <img src="/img/location.svg" />
</MapOverlay>
